module.exports = __webpack_public_path__ + "static/img/contact.8ed29d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/contact.jpg
// module id = R0mv
// module chunks = 1